import script from "./ClientFeedbackCompleted.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientFeedbackCompleted.vue?vue&type=script&setup=true&lang=js"

import "./ClientFeedbackCompleted.vue?vue&type=style&index=0&id=fb5e37b6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb5e37b6"]])

export default __exports__